import { Suspense } from 'react';

import { Icon } from '~/components/Icon';
import { ModalDialog } from '~/components/ModalDialog/ModalDialog';

interface InfoListModalProps {
  title: string;
  items: {
    id: string;
    title: string;
    description: string;
  }[];
}

export function InfoListModal({ title, items }: InfoListModalProps) {
  return (
    <Suspense>
      <ModalDialog>
        <ModalDialog.Trigger>
          <span
            className="ml-xs inline-flex cursor-pointer"
            data-testid="info-modal-trigger"
          >
            <Icon
              type="circle-info"
              variant="light"
              size="sm"
              data-testid="info-icon"
            />
          </span>
        </ModalDialog.Trigger>
        <ModalDialog.Header>{title}</ModalDialog.Header>
        <ModalDialog.Body className="max-h-[22.5rem] space-y-lg">
          {items.map((item) => (
            <div key={item.id} className="flex flex-col gap-xs">
              <p className="text-body-md font-bold text-strong">{item.title}</p>
              <p className="text-body-sm text-default">{item.description}</p>
            </div>
          ))}
        </ModalDialog.Body>
      </ModalDialog>
    </Suspense>
  );
}

InfoListModal.displayName = 'InfoListModal';
